
interface SubscriptionPlanV3 {
  period: "month" | "year";
  name: string;
  trial_days: number;
  price: string;
  included_orders: number;
  extra_orders_rate: string;
  extra_orders_rate_cents: number;
  description?: string;
  staff?: number;
  commission_percent?: number;
}

export interface SubscriptionPlansV3Array extends SubscriptionPlanV3 {
  id: string;
}

interface SubscriptionPlanV2 {
  id: string;
  name: string;
  trial_days: number;
  price: string;
  included_orders: number;
  extra_orders_rate: string;
  extra_orders_rate_cents: number;
}

export const CWSubscriptionPlans = {
  v4: {
    "v4-free": {
      period: "month",
      name: "Starter",
      trial_days: 0,
      price: "0",
      included_orders: 100,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 0,
      description: "100 orders & bookings monthly, no staff accounts",
    },
    "v4-standard-monthly": {
      period: "month",
      name: "Standard",
      price: "39",
      trial_days: 0,
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 5,
      description: "Unlimited orders & bookings & 5 staff accounts",
    },
    "v4-standard-yearly": {
      period: "year",
      name: "Standard",
      price: "390",
      trial_days: 0,
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 5,
      description: "Unlimited orders & bookings & 5 staff accounts",
    },
  } as { [key: string]: SubscriptionPlanV3 },
  v3: {
    // MONTHLY
    "v3-basic": {
      period: "month",
      name: "Basic",
      trial_days: 30,
      price: "29",
      included_orders: 500,
      extra_orders_rate: "0.12",
      extra_orders_rate_cents: 12,
    },
    "v3-pro": {
      period: "month",
      name: "Pro",
      trial_days: 30,
      price: "49",
      included_orders: 1500,
      extra_orders_rate: "0.10",
      extra_orders_rate_cents: 10,
    },
    "v3-premium": {
      period: "month",
      name: "Premium",
      trial_days: 30,
      price: "99",
      included_orders: 4000,
      extra_orders_rate: "0.08",
      extra_orders_rate_cents: 8,
    },
    "v3-enterprise": {
      period: "month",
      name: "Enterprise",
      trial_days: 30,
      price: "199",
      included_orders: 10000,
      extra_orders_rate: "0.05",
      extra_orders_rate_cents: 5,
    },
    // ANNUAL
    "v3-basic-annual": {
      period: "year",
      name: "Basic",
      trial_days: 30,
      price: "290",
      included_orders: 6000,
      extra_orders_rate: "0.12",
      extra_orders_rate_cents: 12,
    },
    "v3-pro-annual": {
      period: "year",
      name: "Pro",
      trial_days: 30,
      price: "490",
      included_orders: 18000,
      extra_orders_rate: "0.10",
      extra_orders_rate_cents: 10,
    },
    "v3-premium-annual": {
      period: "year",
      name: "Premium",
      trial_days: 30,
      price: "990",
      included_orders: 48000,
      extra_orders_rate: "0.08",
      extra_orders_rate_cents: 8,
    },
    "v3-enterprise-annual": {
      period: "year",
      name: "Enterprise",
      trial_days: 30,
      price: "1990",
      included_orders: 120000,
      extra_orders_rate: "0.05",
      extra_orders_rate_cents: 5,
    },
  } as { [key: string]: SubscriptionPlanV3 },
  v2: {
    "v2-free": {
      name: "Free",
      id: "v2-free",
      trial_days: 0,
      price: "0",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
    },
    "v2-basic": {
      name: "Basic",
      id: "v2-basic",
      trial_days: 15,
      price: "9",
      included_orders: 100,
      extra_orders_rate: "0.12",
      extra_orders_rate_cents: 12,
    },
    "v2-pro": {
      name: "Pro",
      id: "v2-pro",
      trial_days: 30,
      price: "29",
      included_orders: 500,
      extra_orders_rate: "0.10",
      extra_orders_rate_cents: 10,
    },
    "v2-premium": {
      name: "Premium",
      id: "v2-premium",
      trial_days: 30,
      price: "49",
      included_orders: 1500,
      extra_orders_rate: "0.08",
      extra_orders_rate_cents: 8,
    },
    "v2-platinum": {
      name: "Platinum",
      id: "v2-platinum",
      trial_days: 45,
      price: "99",
      included_orders: 4000,
      extra_orders_rate: "0.06",
      extra_orders_rate_cents: 6,
    },
    "v2-enterprise": {
      name: "Enterprise",
      id: "v2-enterprise",
      trial_days: 45,
      price: "199",
      included_orders: 10000,
      extra_orders_rate: "0.05",
      extra_orders_rate_cents: 5,
    },
  } as { [key: string]: SubscriptionPlanV2 },
  v1: {
    standard: "standard_pricing", // $0.10 per order
    reseller: "reseller",
  },
};

/*
export const ChargebeeSubscriptionPlansArray = {
  v4: Object.keys(ChargebeeSubscriptionPlans.v4).map((key) => ({ id: key, ...ChargebeeSubscriptionPlans.v4[key as keyof typeof ChargebeeSubscriptionPlans.v4 ] })),
  v3: Object.keys(ChargebeeSubscriptionPlans.v3).map((key) => ({ id: key, ...ChargebeeSubscriptionPlans.v3[key as keyof typeof ChargebeeSubscriptionPlans.v3 ] })),
  v2: Object.keys(ChargebeeSubscriptionPlans.v2).map((key) => ({ ...ChargebeeSubscriptionPlans.v2[key as keyof typeof ChargebeeSubscriptionPlans.v2] })),
};
*/

export const ChargebeeSubscriptionPlans: { [key: string]: SubscriptionPlansV3Array[] | undefined } = {
  "cloudwaitress-test": Object.keys(CWSubscriptionPlans.v4).map((key) => ({ id: key, ...CWSubscriptionPlans.v4[key as keyof typeof ChargebeeSubscriptionPlans.v4 ] })),
  "cloudwaitress": Object.keys(CWSubscriptionPlans.v4).map((key) => ({ id: key, ...CWSubscriptionPlans.v4[key as keyof typeof ChargebeeSubscriptionPlans.v4 ] })),
  "airwaiters": [
    {
      id: "v1-free",
      period: "month",
      name: "FREE",
      trial_days: 0,
      price: "0",
      included_orders: 100,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 0,
      description: "100 orders & bookings monthly, no staff accounts",
    },
    {
      id: "v1-std",
      period: "month",
      name: "STD",
      trial_days: 0,
      price: "49",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 1,
      description: "Unlimited orders & bookings, 1 staff account",
    },
    {
      id: "v1-pro",
      period: "month",
      name: "PRO",
      trial_days: 0,
      price: "99",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 4,
      description: "Unlimited orders & bookings, 4 staff accounts",
    },
    {
      id: "v1-vip",
      period: "month",
      name: "VIP",
      trial_days: 0,
      price: "299",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 999,
      description: "Unlimited orders, bookings & staff + mobile app",
    },
  ],
  "clickconnectmedia": [
    {
      id: "free-starter",
      period: "month",
      name: "Starter",
      trial_days: 0,
      price: "0",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 5,
      description: "5% commission per order, 5 staff accounts",
      commission_percent: 0.05,
    },
    {
      id: "premium",
      period: "month",
      name: "Premium",
      trial_days: 0,
      price: "79",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 999,
      description: "Unlimited orders, bookings & staff",
    },
    {
      id: "enterprise",
      period: "month",
      name: "Enterprise",
      trial_days: 0,
      price: "149",
      included_orders: 0,
      extra_orders_rate: "0",
      extra_orders_rate_cents: 0,
      staff: 999,
      description: "Everything + high priority support",
    },
  ],
};
